import getApiClient from '@/plugins/api'

export default {
    loadReservation() {
        const self = this,
            api = getApiClient(self.$store),
            reservationId = self.$route.params.id

        self.$store.commit('startLoading')

        api.get(`reservations/${reservationId}`, {
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(result => {
                self.reservation = result.data
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    loadAvailableStatuses () {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.get('reservation_statuses')
            .then(result => {
                let data = result.data['hydra:member']

                data.forEach(item => {
                    self.availableStatus.push({
                        label: item.name,
                        value: item.id
                    })
                })
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    updateStatus(item) {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.patch(`/reservations/${item.id}`, {
            status: item.status.toString(),
            reservationStatus: `/reservation_statuses/${item.status}`
        }, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.loadReservation()
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    }
}
